// Maintained by hand: register each new controller here.

import { application } from "./application";

import DebounceController from "./debounce_controller";

application.register("debounce", DebounceController);

import FeaturedFundsController from "./featured_funds_controller";

application.register("featured-funds", FeaturedFundsController);

import IframeHeightController from "./iframe_height_controller";

application.register("iframe-height", IframeHeightController);

import MemberNumbersController from "./member_numbers_controller";

application.register("member-numbers", MemberNumbersController);

import OnboardingsController from "./onboardings_controller";

application.register("onboardings", OnboardingsController);

import ScrollToErrorController from "./scroll_to_error_controller";

application.register("scroll-to-error", ScrollToErrorController);

import ShowTextInputController from "./show_text_input_controller";

application.register("show-text-input", ShowTextInputController);

import SignaturesController from "./signatures_controller";

application.register("signatures", SignaturesController);
